<template>
    <div>
        <div class="button-area">
            <Button @click="back()" class="button-right">返回</Button>
        </div>
        <div class="form-area">
            <Form style="width: 1100px" :model="model" :label-width="110" label-position="left" inline>
                <FormItem :class="{'model-hidden': true}" label="文本框">
                    <Input readonly v-model="model.id" type="text"></Input>
                </FormItem>

                <FormItem label="发起人姓名">
                    <Input readonly v-model="model.name" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="联系方式">
                    <Input readonly v-model="model.concatPhone" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="发起时间">
                    <DatePicker readonly v-model="model.createTime" style="width:320px" type="datetime"
                                format="yyyy-MM-dd"
                                clearable></DatePicker>
                </FormItem>
                <FormItem label="职位">
                    <Input readonly v-model="model.duty" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="单位">
                    <Input readonly v-model="model.deptName" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="走访时间">
                    <DatePicker readonly v-model="model.visitTime" style="width: 320px" type="datetime"
                                format="yyyy-MM-dd"
                                clearable></DatePicker>
                </FormItem>
                <FormItem label="随同人员">
                    <Input readonly v-model="model.followPerson" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="走访内容">
                    <Input readonly v-model="model.visitContent" type="textarea" :rows="6" placeholder=""
                           style="width: 780px"/>
                </FormItem>
                <FormItem label="企业名称">
                    <Input readonly v-model="model.companyName" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="企业联系人">
                    <Input readonly v-model="model.companyConcatName" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="企业联系方式">
                    <Input readonly v-model="model.companyConcatPhone" style="width:320px" type="text"></Input>
                </FormItem>
                <br>
                <FormItem>
                    <h3 style="width: 320px">服务专员反馈详情</h3>
                </FormItem>
                <br>
                <FormItem label="走访反馈时间">
                    <DatePicker readonly v-model="model.visitFeedbackTime" style="width: 320px" type="datetime"
                                format="yyyy-MM-dd"
                                clearable></DatePicker>
                </FormItem>
                <br>
                <FormItem label="走访员反馈详情">
                    <Input readonly v-model="model.visitFeedbackContent" style="width:320px" type="text"></Input>
                </FormItem>
                <br>
                <FormItem label="走访反馈照片">
                    <template v-if="model.visitFeedbackImg && model.visitFeedbackImg.length > 0" >
                        <img v-for="(item,key) in model.visitFeedbackImg" style="width: 200px;height: 160px;margin-right: 10px" :src="item.url" alt="">
                    </template>
                    <template v-else>
                        <img  style="width: 200px;height: 160px" src="../../../../assets/noPic.jpg" alt="">
                    </template>
                </FormItem>
                <br>
                <FormItem>
                    <h3 style="width: 320px">企业反馈详情</h3>
                </FormItem>
                <br>
                <FormItem label="企业反馈时间">
                    <DatePicker readonly v-model="model.companyFeedbackTime" style="width:320px" type="datetime"
                                format="yyyy-MM-dd"
                                clearable></DatePicker>
                </FormItem>
                <br>
                <FormItem label="企业反馈详情">
                    <Input readonly v-model="model.companyFeedbackContent" style="width:320px" type="text"></Input>
                </FormItem>
                <br>
                <FormItem label="企业反馈图片">
                    <template v-if="model.companyFeedbackImg && model.companyFeedbackImg.length > 0" >
                        <img v-for="(item,key) in model.companyFeedbackImg" style="width: 200px;height: 160px;margin-right: 10px" :src="item.url" alt="">
                    </template>
                    <template v-else>
                        <img  style="width: 200px;height: 160px" src="../../../../assets/noPic.jpg" alt="">
                    </template>
                </FormItem>
                <br>
            </Form>
        </div>
    </div>
</template>

<script>
    import util from '@/libs/util.js'

    export default {
        name: 'tqtVisitForm',
        data () {
            return {
                //ID
                id: null,
                saveLoading: false,
                picList: [],
                picListcompany: [],
                //表单参数
                model: {
                    id: '',
                    userId: '',
                    name: '',
                    concatPhone: '',
                    createTime: '',
                    duty: '',
                    deptName: '',
                    visitTime: '',
                    followPerson: '',
                    visitContent: '',
                    companyCode: '',
                    companyName: '',
                    companyConcatName: '',
                    companyConcatPhone: '',
                    visitFeedbackContent: '',
                    visitFeedbackImg: '',
                    visitFeedbackTime: '',
                    companyFeedbackContent: '',
                    companyFeedbackImg: '',
                    companyFeedbackTime: '',
                    status: '',
                    jsfUserId: '',
                }
            }
        },
        mounted () {
            if (typeof (this.$route.query.id) !== 'undefined' && this.$route.query.id !== null && this.$route.query.id !== '') {
                this.id = this.$route.query.id
                //ID存在渲染表单
                this.initForm()
            }
        },
        methods: {
            //保存
            save () {
                if (this.id) {
                    this.update()
                } else {
                    this.create()
                }

            },

            create () {
            },

            update () {
            },

            //渲染表单
            initForm () {
                let _this = this
                util.http
                        .get('/api/visit/tqtVisits/' + this.id, {
                            params: {}
                        })
                        .then(function (response) {
                            let tem = response.data
                            _this.picListcompany = tem.companyFeedbackImg,
                                    _this.picList = tem.visitFeedbackImg,
                                    _this.model = tem
                        })
                        .catch(function (error) {
                            _this.$Notice.error({
                                title: '获取表单失败!'
                            })
                            console.log(error)
                        })
            },

            //返回,需要自定义配置路由
            back () {
                let _this = this
                let tagName = _this.$route.name
                _this.$store.commit('removeTag', tagName)
                _this.$store.commit('closePage', tagName)
                _this.$router.push({
                    name: 'tqt_visit'
                })
            }
        }
    }
</script>

<style scoped>
    .button-area {
        display: flex;
        justify-content: flex-end;
    }

    .button-right-left {
        margin-right: 15px;
    }

    .button-right {
        margin-right: 55px;
    }

    .form-area {
        margin-top: 40px;
        display: flex;
        justify-content: center;
    }

    .form-flex {
        display: flex;
        justify-content: space-between;
    }

    .model-hidden {
        display: none;
    }
    .ivu-form-item{
        margin-right:60px
    }
</style>
